import { gql } from '@apollo/client';

const SAVE_USER_DEVICE_TOKEN = gql`
    mutation SaveUserDeviceToken($input: UserDeviceToken!) {
        saveUserDeviceToken(input: $input) {
            email
            device_arn
        }
    }
`;

const GET_ALL_NOTIFICATIONS = gql`
    query GetNotifications($limit: Int, $page: Int, $readAll: Boolean) {
        getNotifications(limit: $limit, page: $page, read_all: $readAll) {
            current_page
            data {
                createdAt
                description
                id
                message
                meta_data
                read_status
                status
                type
                updatedAt
                user_id
            }
            limit
            total_count
            message
        }
    }
`;
const GET_UNREAD_NOTIFICATION_COUNT = gql`
    query GetUnreadNotificationsCount {
        getUnreadNotificationsCount {
            count
        }
    }
`;

const DELETE_NOTIFICATION = gql`
    mutation DeleteNotification($deleteNotificationId: Int!) {
        deleteNotification(id: $deleteNotificationId) {
            message
            success
        }
    }
`;

export { GET_ALL_NOTIFICATIONS, GET_UNREAD_NOTIFICATION_COUNT, DELETE_NOTIFICATION, SAVE_USER_DEVICE_TOKEN };
